import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { EmailTrackingApi } from "../../api/EmailTrackingApi";
import type { EmailDeliveryResult } from "../../generated/dto/EmailDeliveryResult";
import type { EmailTrackingRef } from "../../generated/dto/EmailTrackingRef";

export class EmailTrackingApiClient implements EmailTrackingApi {
  constructor(private readonly client = useClient()) {}

  async retryPendingEmailsStaff(): Promise<number> {
    const { data } = await this.client.post<unknown>(`/emailtracking/staff/retrypendingemails`);
    return data as number;
  }

  async sendTrackedEmailStaff(email: EmailTrackingRef): Promise<EmailDeliveryResult> {
    const { data } = await this.client.post<unknown>(`/emailtracking/staff/sendtrackedemail`, serializeCbiDto(email, "generated.dto.EmailTrackingRef"));
    return deserializeCbiDto<EmailDeliveryResult>(data, "generated.dto.EmailDeliveryResult");
  }
}

export const useEmailTrackingApi = (): EmailTrackingApi => new EmailTrackingApiClient();
